import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/application-catalog'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the applications endpoint
  onGet (state, payload) {
    let applications = payload.response.data.data
    payload.event.context.applications = applications
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    // payload.event.context.refresh()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/application.js